import Flow from 'types/Flow';
import FlowsByModel from 'types/FlowsByModel';
import { PartteamModel } from 'types/KioskTypes';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import { REOPEN_VERIFY } from './common';
import { PARTTEAM_KEY } from '../../../SelfServices/Steps/common';

type PartteamKioskReopenSteps = SelfServiceSteps.REOPEN_VERIFY | SelfServiceSteps.PARTTEAM_KEY;

const flow: Flow<PartteamKioskReopenSteps> = {
  REOPEN_VERIFY: {
    ...REOPEN_VERIFY,
    next: PARTTEAM_KEY.key,
  },
  PARTTEAM_KEY: {
    ...PARTTEAM_KEY,
    previous: REOPEN_VERIFY.key,
    data: {
      ...PARTTEAM_KEY.data,
      isVisible: true,
    },
  },
};

const PARTTEAM_KIOSK_REOPEN_STEPS: FlowsByModel<PartteamModel> = {
  [PartteamModel.INDOOR]: flow,
  [PartteamModel.OUTDOOR]: flow,
};

export default PARTTEAM_KIOSK_REOPEN_STEPS;
